import * as CONSTS from 'redux/constants';
import * as reduxUtil from 'redux/utils/reducers';
import { cloneDeep } from 'lodash-es';
import {
  RESET_ACTIVATE_PAGE_REDUX_STATE,
  RESET_PIN_FAIL,
  RESET_PIN_START,
  RESET_PIN_SUCCESS,
  RESET_RESET_PIN_REDUX_STATE
} from 'redux/constants/issuing/reset';
import { DON_CODE } from 'consts';

const stateKeys = {
  page: 'page',
  activateCard: 'activateCard',
  cardIssuing: 'cardIssuing',
  resetPIN: 'resetPIN',
  resetPage: 'resetPage',
  setKba: 'setKba',
  setKbaPage: 'setKbaPage',
  viewPIN: 'viewPIN',
  resetRedirected: 'resetRedirected'
};

const initialState = {
  [stateKeys.page]: reduxUtil.initializeObject(),
  [stateKeys.activateCard]: reduxUtil.initializeObject(),
  [stateKeys.cardIssuing]: reduxUtil.initializeObject(),
  [stateKeys.resetPIN]: reduxUtil.initializeObject(),
  [stateKeys.resetPage]: reduxUtil.initializeObject(),
  [stateKeys.setKba]: reduxUtil.initializeObject(),
  [stateKeys.setKbaPage]: reduxUtil.initializeObject(),
  [stateKeys.viewPIN]: reduxUtil.initializeObject(),
  [stateKeys.resetRedirected]: reduxUtil.initializeObject()
};

const reducer = (state = initialState, action) => {
  const { data, error } = action?.payload || {};

  switch (action.type) {
    case CONSTS.GET_ACTIVATE_ISSUE_CARD_PAGE_START:
      return reduxUtil.updateStartAction({ state, key: stateKeys.page });
    case CONSTS.GET_ACTIVATE_ISSUE_CARD_PAGE_SUCCESS:
      return reduxUtil.updateSuccessAction({ state, key: stateKeys.page, data });
    case CONSTS.GET_ACTIVATE_ISSUE_CARD_PAGE_FAIL:
      return reduxUtil.updateFailAction({ state, key: stateKeys.page, error });
    case CONSTS.ACTIVATE_ISSUE_CARD_START:
      return reduxUtil.updateStartAction({ state, key: stateKeys.activateCard });
    case CONSTS.ACTIVATE_ISSUE_CARD_SUCCESS: {
      const {
        updated_page: updatedPage,
        card_issuing,
        activated,
        is_valitor
      } = action.payload.data;
      return {
        ...state,
        ...reduxUtil.updateKeyDataState({
          state,
          key: stateKeys.page,
          data: { ...updatedPage, is_valitor }
        }),
        ...reduxUtil.updateKeyDataState({
          state,
          key: stateKeys.activateCard,
          data: { activated }
        }),
        ...reduxUtil.updateKeyDataState({
          state,
          key: stateKeys.cardIssuing,
          data: card_issuing
        })
      };
    }
    case CONSTS.ACTIVATE_ISSUE_CARD_FAIL:
      return reduxUtil.updateFailAction({ state, key: stateKeys.activateCard, error });
    case CONSTS.GET_RESET_PIN_PAGE_START:
      return reduxUtil.updateStartAction({ state, key: stateKeys.resetPage });
    case CONSTS.GET_RESET_PIN_PAGE_SUCCESS:
      return reduxUtil.updateSuccessAction({ state, key: stateKeys.resetPage, data });
    case CONSTS.GET_RESET_PIN_PAGE_FAIL:
      return reduxUtil.updateFailAction({ state, key: stateKeys.resetPage, error });
    case RESET_PIN_START:
      return reduxUtil.updateStartAction({ state, key: stateKeys.resetPIN });
    case RESET_PIN_SUCCESS: {
      const shouldUpdateActivatePageState = state[stateKeys.page].data?.pin?.length > 0;
      const updatedPIN = action.payload.data.pin;
      return {
        ...state,
        ...reduxUtil.updateSuccessAction({ state, key: stateKeys.resetPIN, data }),
        ...reduxUtil.updateKeyDataState({
          state,
          key: stateKeys.page,
          data: shouldUpdateActivatePageState
            ? { ...state[stateKeys.page].data, pin: updatedPIN }
            : { ...state[stateKeys.page].data }
        }),
        ...reduxUtil.updateKeyDataState({
          state,
          key: stateKeys.resetPage,
          data: { ...state[stateKeys.resetPage].data, status: DON_CODE }
        })
      };
    }
    case RESET_PIN_FAIL:
      return reduxUtil.updateFailAction({ state, key: stateKeys.resetPIN, error });
    case RESET_ACTIVATE_PAGE_REDUX_STATE:
      return cloneDeep(initialState);
    case RESET_RESET_PIN_REDUX_STATE:
      return {
        ...state,
        [stateKeys.resetPIN]: reduxUtil.initializeObject()
      };
    case CONSTS.GET_SET_KBA_PAGE_START:
      return reduxUtil.updateStartAction({ state, key: stateKeys.setKbaPage });
    case CONSTS.GET_SET_KBA_PAGE_SUCCESS:
      return reduxUtil.updateSuccessAction({ state, key: stateKeys.setKbaPage, data });
    case CONSTS.GET_SET_KBA_PAGE_FAIL:
      return reduxUtil.updateFailAction({ state, key: stateKeys.setKbaPage, error });
    case CONSTS.SET_KBA_START:
      return reduxUtil.updateStartAction({ state, key: stateKeys.setKba });
    case CONSTS.SET_KBA_SUCCESS:
      return reduxUtil.updateSuccessAction({ state, key: stateKeys.setKba });
    case CONSTS.SET_KBA_FAIL:
      return reduxUtil.updateFailAction({ state, key: stateKeys.setKba, error });
    case CONSTS.VIEW_PIN_START:
      return reduxUtil.updateStartAction({ state, key: stateKeys.viewPIN });
    case CONSTS.VIEW_PIN_SUCCESS: {
      const { pin, updated_page: updatedPage } = data || {};
      return {
        ...state,
        ...reduxUtil.updateSuccessAction({
          state,
          key: stateKeys.viewPIN,
          data: { pin, showPIN: true }
        }),
        ...reduxUtil.updateKeyDataState({
          state,
          key: stateKeys.resetPage,
          data: { ...state[stateKeys.resetPage].data, ...updatedPage }
        })
      };
    }
    case CONSTS.VIEW_PIN_SHOW_PIN: {
      return {
        ...state,
        ...reduxUtil.updateKeyDataState({
          state,
          key: stateKeys.viewPIN,
          data: { ...state[stateKeys.viewPIN].data, showPIN: data }
        })
      };
    }
    case CONSTS.VIEW_PIN_FAIL:
      return reduxUtil.updateFailAction({ state, key: stateKeys.viewPIN, error });
    case CONSTS.RESET_PIN_REDIRECTED_START:
      return reduxUtil.updateStartAction({ state, key: stateKeys.resetRedirected });
    case CONSTS.RESET_PIN_REDIRECTED_SUCCESS:
      return {
        ...state,
        ...reduxUtil.updateSuccessAction({ state, key: stateKeys.resetRedirected }),
        ...reduxUtil.updateKeyDataState({
          state,
          key: stateKeys.resetPage,
          data: { ...state[stateKeys.resetPage].data, ...data }
        })
      };
    case CONSTS.RESET_PIN_REDIRECTED_FAIL:
      return reduxUtil.updateFailAction({ state, key: stateKeys.resetRedirected, error });
    default:
      return state;
  }
};

export default reducer;
